/**
 * `inquiries` — les demandes reçues (base galerie, 4.1).
 */
import { z } from 'zod';
import { CHAMPS_DOCUMENT, emailSchema, idSchema, langueSchema, withAudit } from './commun.js';
export const SOURCES_DEMANDE = [
    'site',
    'viewing_room',
    'catalogue_visite',
    'espace_collectionneur',
    'espace_deposant',
    'regie',
];
export const sourceDemandeSchema = z.enum(SOURCES_DEMANDE);
export const ETATS_DEMANDE = ['a_traiter', 'repondue', 'close'];
export const etatDemandeSchema = z.enum(ETATS_DEMANDE);
export const inquirySchema = withAudit(z.object({
    _id: idSchema,
    oeuvreId: idSchema.optional(),
    expositionId: idSchema.nullable().default(null),
    contactId: idSchema.optional(),
    nom: z.string().min(1),
    email: emailSchema,
    telephone: z.string().optional(),
    langue: langueSchema.default('fr'),
    message: z.string().min(1),
    source: sourceDemandeSchema.default('site'),
    etat: etatDemandeSchema.default('a_traiter'),
    assigneeA: idSchema.optional(),
    recueLe: z.date(),
    repondueLe: z.date().optional(),
}));
export const inquiryCreationSchema = inquirySchema.omit({
    ...CHAMPS_DOCUMENT,
    etat: true,
    repondueLe: true,
});
export const inquiryMiseAJourSchema = inquirySchema
    .pick({ etat: true, assigneeA: true, contactId: true, repondueLe: true })
    .partial();
//# sourceMappingURL=inquiries.js.map